import React, { useMemo, useState } from 'react'
import { Row, Col, Image, Form, Button, Alert } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import Card from '../../../components/Card'

// img
import auth5 from '../../../assets/images/auth/05.png'
import UserService from '../../../services/user/UserService'
import SweetAlert from 'react-bootstrap-sweetalert'

const SignUp = () => {
   let history = useNavigate()
   const [currentPassword, setCurrentPassword] = useState("");
   const [newPassword, setNewPassword] = useState("");
   const [confirmPassword, setConfirmPassword] = useState("");
   const [message, setMessage] = useState("");
   const [variant, setVariant] = useState("success");
   const [showUpdateSuccess, setShowUpdateSuccess] = useState(false)
   const [showUpdateFailed, setShowUpdateFailed] = useState(false)

   const userService = useMemo(() => new UserService(), [])

   const handleSubmit = (e) => {
      e.preventDefault();
      if (newPassword !== confirmPassword) {
         setMessage("New password and confirm password do not match!");
         setVariant("danger");
         return;
      }

      let jsonData = {
         "username": localStorage.getItem("username"),
         "oldPassword": currentPassword,
         "newPassword": newPassword
      }
      userService.updatePass(jsonData).then((response) => {
         console.log(response)
         setMessage(response.data);
         setVariant("success");
         setShowUpdateSuccess(true)
      }).catch((error) => {
         setMessage("Error updating password: " + error.response.data.message);
         setVariant("danger");
         setShowUpdateFailed(true)
      })

   };

   const handleClickUpdateSuccess = () => {
      setShowUpdateSuccess(false)
      history('/dashboard')
   }

   const handleClickUpdateFailed = () => {
      setShowUpdateFailed(false)
   }


   return (
      <>
         <section className="login-content">
            <Row className="m-0 align-items-center bg-white vh-100">
               <div className="col-md-6 d-md-block d-none bg-primary p-0 mt-n1 vh-100 overflow-hidden">
                  <Image src={auth5} className="Image-fluid gradient-main animated-scaleX" alt="images" />
               </div>
               <Col md="6">
                  <Row className="justify-content-center">
                     <Col md="10">
                        <Card className="card-transparent auth-card shadow-none d-flex justify-content-center mb-0">
                           <Card.Body>
                              <div className="container mt-5">
                                 <h3>Update Password</h3>
                                 {message && <Alert variant={variant}>{message}</Alert>}
                                 <Form onSubmit={handleSubmit}>
                                    <Form.Group controlId="formCurrentPassword" className='mt-3'>
                                       <Form.Label>Current Password</Form.Label>
                                       <Form.Control
                                          type="password"
                                          placeholder="Enter current password"
                                          value={currentPassword}
                                          onChange={(e) => setCurrentPassword(e.target.value)}
                                       />
                                    </Form.Group>

                                    <Form.Group controlId="formNewPassword" className='mt-3'>
                                       <Form.Label>New Password</Form.Label>
                                       <Form.Control
                                          type="password"
                                          placeholder="Enter new password"
                                          value={newPassword}
                                          onChange={(e) => setNewPassword(e.target.value)}
                                          required
                                       />
                                    </Form.Group>

                                    <Form.Group controlId="formConfirmPassword" className='mt-3'>
                                       <Form.Label>Confirm New Password</Form.Label>
                                       <Form.Control
                                          type="password"
                                          placeholder="Confirm new password"
                                          value={confirmPassword}
                                          onChange={(e) => setConfirmPassword(e.target.value)}
                                          required
                                       />
                                    </Form.Group>

                                    <Button variant="primary" type="submit" className='mt-3'>
                                       Update Password
                                    </Button>
                                 </Form>
                              </div>
                           </Card.Body>
                        </Card>
                     </Col>
                  </Row>
                  <div className="sign-bg sign-bg-right">
                     <svg width="280" height="230" viewBox="0 0 421 359" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g opacity="0.05">
                           <rect x="-15.0845" y="154.773" width="543" height="77.5714" rx="38.7857" transform="rotate(-45 -15.0845 154.773)" fill="#3A57E8" />
                           <rect x="149.47" y="319.328" width="543" height="77.5714" rx="38.7857" transform="rotate(-45 149.47 319.328)" fill="#3A57E8" />
                           <rect x="203.936" y="99.543" width="310.286" height="77.5714" rx="38.7857" transform="rotate(45 203.936 99.543)" fill="#3A57E8" />
                           <rect x="204.316" y="-229.172" width="543" height="77.5714" rx="38.7857" transform="rotate(45 204.316 -229.172)" fill="#3A57E8" />
                        </g>
                     </svg>
                  </div>
               </Col>
            </Row>
         </section>
         {
            showUpdateSuccess &&
            <SweetAlert
               title="Success"
               success
               onConfirm={handleClickUpdateSuccess}
               btnSize="sm"
               timeout={5000}
            >
               {message}
            </SweetAlert>
         }
         {
            showUpdateFailed &&
            <SweetAlert
               title="Gagal"
               danger
               onConfirm={handleClickUpdateFailed}
               btnSize="sm"
            >
               {message}
            </SweetAlert>
         }
      </>
   )
}

export default SignUp
